export enum BusinessPolicyNumberOperator {
  EQUAL_TO = 'EQUAL_TO',
  DIFFERENT_THAN = 'DIFFERENT_THAN',
  BIGGER_THAN_OR_EQUAL_TO = 'BIGGER_THAN_OR_EQUAL_TO',
  LESS_THAN_OR_EQUAL_TO = 'LESS_THAN_OR_EQUAL_TO',
  BIGGER_THAN = 'BIGGER_THAN',
  LESS_THAN = 'LESS_THAN',
}
